<button fxLayout="row" fxLayoutAlign="center center" class="icon-button" mat-icon-button (click)="onClickButton($event)" [disabled]="disabled" [loading]="isLoading">
    <mat-icon class="mr-8" *ngIf="icon">{{ icon }}</mat-icon>
    <mat-icon class="mr-8" *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>
</button>
